import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "../../../axios/index";

// styles
import styles from "./ContactUsPage.module.css";
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "../HomeNavbar/HomeNavbar";
import Footer from "../Footer/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contactusValidate } from "./contactusValidate";

const ContactUsPage = () => {
  const [btnLoader, setBtnLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState(true);
  const [siteData, setSiteData] = useState([]);
  const [foramData, setForamData] = useState({
    fullName: "",
    company: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  // const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))

  const formChangeHandler = e => {
    if (e.target.name === "email") {
      setForamData(prev => {
        return { ...prev, email: e.target.value };
      });
    } else if (e.target.name === "phoneNumber") {
      if (e.target.value === "" || e.target.value.match(/^[0-9]+$/)) {
        if (e.target.value.length <= 11) {
          setForamData(prev => {
            return { ...prev, [e.target.name]: e.target.value };
          });
        } else {
          setForamData(prev => {
            return { ...prev, phoneNumber: "" };
          });
        }
      } else {
        setForamData(prev => {
          return { ...prev, phoneNumber: "" };
        });
      }
    } else {
      setForamData(prev => {
        return { ...prev, [e.target.name]: e2p(e.target.value) };
      });
    }
  };

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)
      const getContactedData = await axios.get("SiteSetting");
      const messages = getContactedData.data.data;
      // console.log(messages)
      setSiteData(messages);
      setIsLoading(false);
    };

    dataHandler();
  }, []);

  useEffect(() => {
    setErrors(contactusValidate(foramData));
    // console.log(errors)
  }, [foramData]);

  return (
    <>
      <Helmet>
        <title>تماس با ما | آذر ملک</title>
        <meta name="description" content="تماس با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta
          name="keywords"
          content="اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز, اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز"
        />
        <meta content="index , follow" name="robots" />
        <meta name="og:title" content="تماس با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta name="description" content="تماس با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta name="og:description" content="تماس با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
        <meta rel="canonical" href="https://azrmelk.com/تماس-با-ما" />
        <meta content="website" property="og:type" />
        <meta content="https://azrmelk.com" name="twitter:site" />
        <meta content="https://azrmelk.com/تماس-با-ما" property="og:url" />
      </Helmet>

      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar ContactUs />
            <div className="container py-3 px-0">
              <div className="w-100 d-flex justify-content-start flex-wrap align-items-center mt-3 px-md-2 px-3" dir="rtl">
                <div className="d-flex align-items-center justify-content-center mt-2 mb-4">
                  <h1 className={styles.title}>تماس با ما</h1>
                </div>
              </div>
            </div>
            <section className={`container-fluid d-flex align-items-center mb-5 ${styles.bg_dark}`}>
              <div className="container py-3 px-0">
                <div className="w-100 d-flex justify-content-md-between justify-content-start flex-wrap align-items-center" dir="rtl">
                  <div className="d-flex flex-column align-items-start justify-content-center mx-md-0 mx-4 my-md-0 my-3">
                    <h3 className={`mb-3 ${styles.header_title}`}>
                      <svg className="ms-2" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.43752 7.5C3.43752 5.53249 5.0325 3.9375 7.00002 3.9375C8.96753 3.9375 10.5625 5.53249 10.5625 7.5C10.5625 9.46751 8.96753 11.0625 7.00002 11.0625C5.0325 11.0625 3.43752 9.46751 3.43752 7.5ZM7.00002 5.0625C5.65382 5.0625 4.56252 6.15381 4.56252 7.5C4.56252 8.84619 5.65382 9.9375 7.00002 9.9375C8.34621 9.9375 9.43752 8.84619 9.43752 7.5C9.43752 6.15381 8.34621 5.0625 7.00002 5.0625Z"
                          fill="#B6B6B6"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.643291 6.64264C0.909037 3.41868 3.60315 0.9375 6.83804 0.9375H7.162C10.3969 0.9375 13.091 3.41868 13.3567 6.64264C13.4995 8.3745 12.9645 10.0942 11.8645 11.4394L8.26975 15.8358C7.6135 16.6383 6.38654 16.6384 5.73029 15.8358L2.13549 11.4394C1.0355 10.0942 0.500537 8.3745 0.643291 6.64264ZM6.83804 2.0625C4.18864 2.0625 1.98214 4.09461 1.76449 6.73506C1.64568 8.17644 2.09091 9.60768 3.00641 10.7273L6.6012 15.1236C6.80733 15.3757 7.19271 15.3757 7.39884 15.1236L10.9936 10.7273C11.9091 9.60767 12.3544 8.17644 12.2355 6.73506C12.0179 4.09461 9.8114 2.0625 7.162 2.0625H6.83804Z"
                          fill="#B6B6B6"
                        />
                      </svg>
                      آدرس شرکت
                    </h3>
                    <p className={`mt-2 ${styles.header_text}`}>{siteData?.address}</p>
                  </div>
                  <div className="d-flex flex-column align-items-start justify-content-center mx-md-0 mx-4 my-md-0 my-3">
                    <h3 className={`mb-3 ${styles.header_title}`}>
                      <svg className="ms-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.374573 12.1889C0.467193 12.071 0.591801 11.9385 0.742308 11.7861C1.06362 11.4597 1.5784 11.0809 2.0726 10.7559C2.57234 10.4273 3.09842 10.1228 3.46458 9.95209L3.46481 9.95198L3.46504 9.95187C3.67309 9.85512 3.86162 9.76793 4.02685 9.70663C4.19465 9.64439 4.37922 9.59266 4.58064 9.59233C5.00225 9.59163 5.32765 9.82047 5.62777 10.0409C5.71399 10.1042 5.78465 10.158 5.84554 10.2044C5.97681 10.3044 6.06285 10.3699 6.16237 10.4224C6.25945 10.4735 6.32954 10.4885 6.44237 10.4643C6.60506 10.4293 6.96119 10.2775 7.42708 9.98265C7.87764 9.69751 8.38583 9.30711 8.8508 8.84066C9.31567 8.37431 9.69577 7.87419 9.97082 7.43262C10.2542 6.9776 10.3997 6.6272 10.4354 6.45982C10.4603 6.34334 10.4447 6.2706 10.3941 6.17334C10.3407 6.07072 10.271 5.97943 10.1626 5.83748C10.12 5.78169 10.0715 5.71808 10.0156 5.64288L10.0155 5.64276L10.0112 5.63709C9.7875 5.33593 9.5389 5.00134 9.53935 4.57722C9.53957 4.36768 9.59874 4.17959 9.66634 4.014C9.73093 3.85578 9.82249 3.67401 9.92294 3.47462L9.93134 3.45793C10.1076 3.10846 10.4061 2.58884 10.7315 2.08581C11.0512 1.59165 11.4244 1.07023 11.7516 0.745567L11.752 0.745087C11.9045 0.59416 12.0369 0.469236 12.1548 0.376394C12.2689 0.286515 12.4165 0.187863 12.6002 0.146259C12.807 0.0993895 12.9791 0.141874 13.0984 0.185434C13.1522 0.205067 13.2039 0.228229 13.2408 0.244857C13.2466 0.24745 13.2522 0.249981 13.2577 0.252462C13.292 0.267904 13.3219 0.28139 13.3561 0.295697L13.357 0.296042L13.3578 0.296391C13.7062 0.443333 14.0404 0.622074 14.356 0.830341L14.357 0.830965L14.3579 0.831593C14.9693 1.23856 15.3688 1.62141 15.646 2.21651C15.79 2.52576 15.9355 2.96762 15.8499 3.6543C15.7675 4.31479 15.4751 5.17406 14.8183 6.34682L14.8181 6.34711C13.7656 8.22379 12.8582 9.52597 11.1831 11.2057C9.51294 12.8806 8.42288 13.7038 6.3279 14.857C4.21884 16.018 2.91825 16.0163 2.20978 15.6848C1.61494 15.4064 1.23386 15.0029 0.829017 14.3936L0.82822 14.3924L0.827428 14.3912C0.619822 14.0752 0.441589 13.7409 0.294962 13.3924L0.294478 13.3912L0.294 13.3901C0.279669 13.3556 0.266146 13.3254 0.250685 13.2909C0.248261 13.2855 0.245789 13.28 0.243259 13.2743C0.226674 13.2373 0.203619 13.1856 0.184086 13.1318C0.140792 13.0126 0.0985008 12.8409 0.145052 12.6345C0.186441 12.4509 0.284759 12.3032 0.374573 12.1889ZM1.33236 12.9571C1.45208 13.2415 1.59752 13.5143 1.76687 13.7722C2.10902 14.287 2.34868 14.5077 2.68662 14.6658C2.91121 14.7709 3.79804 14.9655 5.78539 13.8715C7.78681 12.7698 8.79136 12.011 10.3865 10.4114C11.9766 8.81678 12.8249 7.60111 13.8367 5.79709C14.455 4.69313 14.6759 3.97741 14.7335 3.51509C14.7879 3.07897 14.7001 2.85022 14.6262 2.69154C14.4676 2.35097 14.2484 2.11023 13.7354 1.76865C13.478 1.59888 13.2054 1.45313 12.9213 1.33326C12.8826 1.31709 12.8469 1.30124 12.8171 1.28783C12.7548 1.34029 12.6687 1.42063 12.5439 1.54425C12.3085 1.77791 11.9901 2.21158 11.6761 2.69691C11.3678 3.17339 11.0906 3.6577 10.936 3.96426C10.8245 4.18556 10.7536 4.32729 10.7079 4.43917C10.6635 4.54801 10.6644 4.57965 10.6644 4.57841C10.6644 4.56823 10.6445 4.60299 10.9185 4.97185C10.9465 5.00954 10.9778 5.05027 11.0108 5.09338C11.1368 5.25773 11.2894 5.45673 11.392 5.65391C11.5454 5.94854 11.6226 6.28679 11.5357 6.69448C11.4596 7.05129 11.234 7.5325 10.9257 8.02741C10.6091 8.53575 10.1769 9.10386 9.64756 9.63489C9.11831 10.1658 8.54334 10.6076 8.02869 10.9333C7.52936 11.2493 7.03822 11.487 6.67849 11.5642C6.2689 11.6521 5.93065 11.572 5.63775 11.4176C5.44901 11.3181 5.25399 11.1693 5.09348 11.0469C5.04626 11.0109 5.00202 10.9771 4.96181 10.9476C4.63984 10.7111 4.58852 10.7167 4.58292 10.7173C4.58273 10.7173 4.5826 10.7173 4.58251 10.7173C4.57167 10.7173 4.53014 10.7198 4.41812 10.7614C4.30355 10.8039 4.15857 10.8701 3.93953 10.9719C3.64122 11.111 3.16553 11.3837 2.69074 11.6959C2.21045 12.0117 1.77802 12.3375 1.54383 12.5755L1.54344 12.576L1.54304 12.5764C1.41897 12.702 1.33856 12.7883 1.28621 12.8507C1.29976 12.881 1.31589 12.9175 1.33236 12.9571Z"
                          fill="#B6B6B6"
                        />
                      </svg>
                      شماره تماس
                    </h3>
                    <p className="d-flex align-items-center justify-content-center">
                      <div className={`mt-2 ${styles.header_text}`}>{siteData?.phoeNumber?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                      <div className={`mx-2 ${styles.rounded}`}></div>
                      <div className={`mt-2 ${styles.header_text}`}>{siteData?.landlinePhone?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                    </p>
                  </div>
                  <div className="d-flex flex-column align-items-start justify-content-center mx-md-0 mx-4 my-md-0 my-3">
                    <h3 className={`mb-3 ${styles.header_title}`}>شبکه های اجتماعی</h3>
                    <p className="d-flex align-items-center justify-content-center">
                      <a href={siteData?.whatsApp}>
                        <svg className="ms-5" xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="white" viewBox="0 0 16 16">
                          <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                        </svg>
                      </a>
                      <a href={siteData?.telegram}>
                        <svg className="ms-5" xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="white" viewBox="0 0 16 16">
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                        </svg>
                      </a>

                      <a href={siteData?.instagram}>
                        <svg className="me-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M17.0836 5.65587C17.0836 4.95512 17.6526 4.38705 18.3545 4.38705C19.0564 4.38705 19.6254 4.95512 19.6254 5.65587C19.6254 6.35663 19.0564 6.9247 18.3545 6.9247C17.6526 6.9247 17.0836 6.35663 17.0836 5.65587Z"
                            fill="white"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 5.97308C8.66595 5.97308 5.96318 8.67142 5.96318 12C5.96318 15.3286 8.66595 18.0269 12 18.0269C15.334 18.0269 18.0368 15.3286 18.0368 12C18.0368 8.67142 15.334 5.97308 12 5.97308ZM7.86954 12C7.86954 9.72255 9.7188 7.87632 12 7.87632C14.2812 7.87632 16.1304 9.72255 16.1304 12C16.1304 14.2774 14.2812 16.1237 12 16.1237C9.7188 16.1237 7.86954 14.2774 7.86954 12Z"
                            fill="white"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M18.6827 0.368696C14.277 -0.122899 9.72296 -0.122899 5.31727 0.368696C2.76014 0.654026 0.695765 2.66513 0.395129 5.23136C-0.13171 9.72846 -0.13171 14.2715 0.395129 18.7686C0.695765 21.3349 2.76014 23.346 5.31727 23.6313C9.72296 24.1229 14.277 24.1229 18.6827 23.6313C21.2399 23.346 23.3042 21.3349 23.6049 18.7686C24.1317 14.2715 24.1317 9.72846 23.6049 5.23136C23.3042 2.66513 21.2399 0.654026 18.6827 0.368696ZM5.52902 2.26016C9.79398 1.78427 14.206 1.78427 18.471 2.26016C20.1614 2.44878 21.5156 3.78056 21.7114 5.45246C22.221 9.80266 22.221 14.1973 21.7114 18.5475C21.5156 20.2194 20.1614 21.5512 18.471 21.7398C14.206 22.2157 9.79398 22.2157 5.52902 21.7398C3.83858 21.5512 2.48444 20.2194 2.28858 18.5475C1.77895 14.1973 1.77895 9.80266 2.28858 5.45246C2.48444 3.78056 3.83858 2.44878 5.52902 2.26016Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </p>
                  </div>
                  <div className="d-flex flex-column align-items-start justify-content-center mx-md-0 mx-4 my-md-0 my-3">
                    <h3 className={`mb-3 ${styles.header_title}`}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="ms-2" viewBox="0 0 16 16">
                        <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
                        <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                      </svg>
                      ایمیل
                    </h3>
                    <p className="d-flex align-items-center justify-content-center">
                      <div className={`mt-2 ${styles.header_text}`}>{siteData?.email}</div>
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="container py-3 px-0">
              <div className="w-100 d-flex justify-content-center flex-wrap align-items-center mt-3 px-md-2 px-3" dir="rtl">
                <div className="w-100 d-flex align-items-center justify-content-center">
                  <h2 className={styles.title}>برای ارتباطات بیشتر...</h2>
                </div>
                <div className="w-100 d-flex flex-column align-items-center justify-content-center px-5">
                  <from className="w-100 d-flex align-items-center justify-content-md-between justify-content-center my-3 flex-wrap">
                    <label className={`d-flex align-items-start justify-content-center flex-column ms-2 my-3 ${styles.input_container}`}>
                      <h3 className={`mb-3 ${styles.input_header}`}>نام و نام خانوادگی</h3>
                      <input type="text" name="fullName" value={foramData.fullName} onChange={formChangeHandler} className={`pe-3 ${styles.input}`} />
                    </label>
                    <label className={`d-flex align-items-start justify-content-center flex-column ms-2 my-3 ${styles.input_container}`}>
                      <h3 className={`mb-3 ${styles.input_header}`}>شرکت (اختیاری)</h3>
                      <input type="text" name="company" value={foramData.company} onChange={formChangeHandler} className={`pe-3 ${styles.input}`} />
                    </label>
                    <label className={`d-flex align-items-start justify-content-center flex-column ms-2 my-3 ${styles.input_container}`}>
                      <h3 className={`mb-3 ${styles.input_header}`}>ایمیل</h3>
                      <input type="text" name="email" value={foramData.email} onChange={formChangeHandler} className={`pe-3 ${styles.input}`} />
                    </label>
                    <label className={`d-flex align-items-start justify-content-center flex-column ms-2 my-3 ${styles.input_container}`}>
                      <h3 className={`mb-3 ${styles.input_header}`}>شماره تماس</h3>
                      <input type="text" name="phoneNumber" value={foramData.phoneNumber} onChange={formChangeHandler} className={`pe-3 ${styles.input}`} />
                    </label>
                    <label className="w-100 d-flex align-items-start justify-content-center flex-column ms-2 my-3">
                      <h3 className={`mb-3 ${styles.input_header}`}>پیام شما</h3>
                      <textarea
                        type="text"
                        name="message"
                        value={foramData.message}
                        onChange={formChangeHandler}
                        className={`w-100 px-3 pt-3 ${styles.textarea}`}></textarea>
                    </label>
                    <div className="w-100 my-4">
                      <div className="container-fluid">
                        <div className="d-flex justify-content-start flex-wrap align-items-center mt-3" dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                            {btnLoader ? (
                              <div className={Dstyles.btn_loader_container}>
                                <div className={Dstyles.btn_spinner}></div>
                              </div>
                            ) : (
                              <button className={`${Dstyles.filled_blue} text-white border-0`} onClick={submitHandler}>
                                {" "}
                                ثبت{" "}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </from>
                </div>
              </div>
            </section>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال ارسال پیام شما", "success");
    } else {
      notify("!لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      setBtnLoader(false);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      formSendHandler();
    } else if (type === "success-post") {
      setBtnLoader(false);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (type === "error-post") {
      setBtnLoader(false);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setBtnLoader(false);
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function formSendHandler() {
    setBtnLoader(true);
    var data = new FormData();
    data.append("Subject", foramData.company);
    data.append("Email", foramData.email);
    data.append(
      "PhoneNumber",
      foramData.phoneNumber.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    );
    data.append("FullName", foramData.fullName);
    data.append("MessageBody", foramData.message);
    const aboutusTexts = await axios.post("ContactUs", data);
    // console.log(aboutusTexts.data)
    if (aboutusTexts.data.isSuccess) {
      notify("پیام شما با موفقیت ارسال شد", "success-post");
    } else {
      notify(aboutusTexts.data.metaData.message, "error-post");
    }

    setBtnLoader(false);
  }
};

export default ContactUsPage;
